export default __webpack_public_path__ + "static/media/NunitoSans-SemiBold.05c6cb4d.woff";